import { PushEffects } from './push.effect';

export const effects: any[] = [PushEffects];

export * from './push.effect';
